module.exports = __webpack_public_path__ + "static/media/mews_v3_logo_1.69521ec9.png";